import axios from "axios";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

function truncateHtml(htmlString, limit) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  const text = tempDiv.textContent || tempDiv.innerText || "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
}

export default function PropertyListing({ propertyListing = [] }) {
  const [properties, setProperties] = useState(propertyListing);
  const [canLoadMore, setCanLoadMore] = useState(true);
  const [page, setPage] = useState(1);
  const location = useLocation();
  const isExactMatch = location.pathname === "/properties";

  // ✅ Move loadProperties outside useEffect
  const loadProperties = async (currentPage = 1) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_PATH}properties/public`, {
        params: { page: currentPage, size: 6, order: "DESC" },
      });

      const { error, data } = response.data;

      if (!error && Array.isArray(data)) {
        // setProperties((prev) => [...prev, ...data]);
        setProperties((prev) => {
          const merged = [...prev, ...data];
          const unique = merged.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
          );
          return unique;
        });

        setPage(currentPage);
      } else {
        setCanLoadMore(false);
      }
    } catch (err) {
      console.error("Error loading properties:", err);
    }
  };

  useEffect(() => {
    if (propertyListing.length < 1 ) {
      loadProperties();
    }
  }, [propertyListing.length]);

  if (properties.length < 1) {
    return "";
  }

  return (
    <div className="container-xxl py-5">
      <div className="container">
        {propertyListing.length < 1 && (
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h1 className="mb-3">Available Properties</h1>
            <p>Our properties includes the following</p>
          </div>
        )}
        <div className="tab-content">
          <div className="tab-pane fade show p-0 active">
            <div className="row g-4">
              {properties.map((item, i) => (
                <div key={i} className="col-lg-4 col-md-6">
                  <div className="property-item rounded overflow-hidden shadow-sm border">
                    <div className="position-relative overflow-hidden">
                      <Link to={`/properties/${item.slug}`}>
                        <img
                          className="img-fluid w-100 object-cover"
                          src={item.rootImagePath + item.defaultImage}
                          alt={item.name}
                          onError={(e) => (e.target.src = "/favicon.ico")}
                        />
                      </Link>
                      <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-3 py-1 px-3">
                        Available
                      </div>
                      {/* <div className="bg-white rounded-top text-primary position-absolute start-0 bottom-0 mx-3 pt-1 px-3">
                        Land
                      </div> */}
                    </div>
                    <div className="p-4 pb-0">
                      <h5 className="text-primary mb-2">{item.name}</h5>
                      <Link to={`/properties/${item.slug}`} className="d-block h5 mb-2">
                        {item.shortDescription}
                      </Link>
                      {/* <p className="text-muted mb-1">
                        <i className="fa fa-map-marker-alt text-primary me-2"></i>
                        {item?.location?.length > 200
                          ? `${item.location.slice(0, 200)}...`
                          : item.location}
                      </p> */}
                      <p
                        className="text-sm text-gray-700"
                        dangerouslySetInnerHTML={{
                          __html: truncateHtml(item.fullDescription, 200),
                        }}
                      />
                    </div>
                    {/* <div className="d-flex border-top">
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-ruler-combined text-primary me-2"></i>300 SQM
                      </small>
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-ruler-combined text-primary me-2"></i>500 SQM
                      </small>
                    </div> */}
                  </div>
                </div>
              ))}

              <div className="col-12 text-center">
                {isExactMatch ? (
                  canLoadMore && (
                    <Button
                      onClick={() => {
                        loadProperties(page + 1);
                      }}
                      className="btn btn-primary py-3 px-5 mt-4"
                    >
                      Browse More Property
                    </Button>
                  )
                ) : (
                  <Link to="/properties" className="btn btn-primary py-3 px-5 mt-4">
                    Browse More Property
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}